import UserResolver from '../authentication/user-resolver';
import searchResult from '../search/search-result.component';
import SearchService from '../search/search.service';
import { useNewDesign } from './design-refresh';

// The 2026 page with the flag on; the legacy component otherwise (its controller reads $transition$).
const SEARCH_TEMPLATE = `
  <ut-search-page ng-if="$resolve.useNewDesign" [user]="$resolve.user"></ut-search-page>
  <search-result ng-if="!$resolve.useNewDesign" $transition$="$resolve.$transition$" user="$resolve.user"></search-result>
`;

const SearchRouter = {
  route: (module) => {
    module
      .service('SearchService', SearchService)
      .component('searchResult', searchResult)
      .config(['$stateProvider', ($stateProvider) => {
        $stateProvider
          .state('searchresultbytag', {
            parent: 'root',
            url: '/search-result/:contentType/tagged/:query',
            template: SEARCH_TEMPLATE,
            resolve: {
              user: UserResolver,
              useNewDesign,
              title: [() => 'uTest - Search Results'],
            },
          })
          .state('searchresultbyhashtag', {
            parent: 'root',
            url: '/search-result/:contentType/hashtag/:query',
            template: SEARCH_TEMPLATE,
            resolve: {
              user: UserResolver,
              useNewDesign,
              title: [() => 'uTest - Search Results'],
            },
          })
          .state('searchresult', {
            parent: 'root',
            url: '/search-result/:contentType/:query',
            template: SEARCH_TEMPLATE,
            resolve: {
              user: UserResolver,
              useNewDesign,
              title: [() => 'uTest - Search Results'],
            },
          });
      }]);
  },
};

export default SearchRouter;
